var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tabs",class:_vm.classes},[_vm._t("default"),_c('div',{staticClass:"ui-tabs__right"},[_vm._t("right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }